module.exports = __webpack_public_path__ + "static/media/paddle.b0ddd279.png";